import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">LAYTON PACE</h3>
            <p className="text-gray-500 text-sm">
              Loyal, playful, and worth getting to know.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="flex flex-col space-y-2">
              <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                Home
              </Link>
              <Link to="/pictures" className="text-gray-400 hover:text-white transition-colors text-sm">
                Photos
              </Link>
              <a href="/#connect" className="text-gray-400 hover:text-white transition-colors text-sm">
                Connect
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
            <div className="flex flex-col space-y-3">
              <a 
                href="/#connect" 
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                Send a Message
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-900">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Layton Pace. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs italic">
              Serious about finding the right person. Never serious all the time.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
